// Arrowhead of a dimension, as in the lock calculator (port of its Arrowhead): a cone whose tip lands on `tip`, the
// body extending back against `direction`.
import { memo, useMemo, type FC } from "react";
import * as THREE from "three";
import { QUOTE } from "./viewerConfig";

export type ArrowheadProps = {
  tip: THREE.Vector3;
  // where the arrow points (any length)
  direction: THREE.Vector3;
  color: THREE.Color;
  length: number;
  width: number;
};

const UNIT_Y = new THREE.Vector3(0, 1, 0);

const Arrowhead: FC<ArrowheadProps> = ({ tip, direction, color, length, width }) => {
  const { position, quaternion } = useMemo(() => {
    const dir = direction.clone();
    if (dir.lengthSq() < 1e-12) dir.set(0, 1, 0);
    dir.normalize();
    return {
      position: tip.clone().addScaledVector(dir, -length / 2),
      quaternion: new THREE.Quaternion().setFromUnitVectors(UNIT_Y, dir),
    };
  }, [tip, direction, length]);

  return (
    <mesh position={position} quaternion={quaternion}>
      <coneGeometry args={[width / 2, length, QUOTE.arrowConeSegments]} />
      <meshBasicMaterial color={color} />
    </mesh>
  );
};

export default memo(Arrowhead);
